import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getProjectDetail } from 'apis/project.ts'

import OpenIcon from 'assets/icons/detail-openIcon.svg'

// let portfolio = {
//   name: '스카이온',
//   description: '유지보수 및 리뉴얼 개발',
//   client: '(주)구마일에듀 (자회사)',
//   link: 'https://skyon.kr/',
//   topImg: require('assets/images/detail-skyon_top.png'),
//   bottomImg: require('assets/images/detail-skyon_bottom.png'),
//   projectType: '반응형 웹사이트, 실시간 화상 수업',
//   projectDescription: '유지보수 및 리뉴얼 개발',
//   projectDuration: '2023.05 ~ 2023.07',
// }

export default function PortfolioDetail() {
  const params = useParams()
  const [portfolio, setPortfolio] = useState({})

  const getProjectDetailApi = async () => {
    let getProjectDetailResponse = await getProjectDetail(params.portfolioKey)
    if (getProjectDetailResponse.error) {
      console.log(getProjectDetailResponse.message)
      return
    }
    setPortfolio(getProjectDetailResponse.data.project)
    console.log(getProjectDetailResponse.data.project)
  }

  useEffect(() => {
    getProjectDetailApi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='wrapper'>
      <div className='py-64'>
        {/* topImg */}
        <div className='py-30'>
          <div className='relative pt-40 pb-[70px] flex flex-col items-center gap-32'>
            <div className='z-[2]'>
              <img src={portfolio.topImg} alt='' className='w-[626px]' />
            </div>
            <div className='bottom-[0px] absolute w-full h-[110px] home_background1 z-[1]'></div>
          </div>
        </div>

        {/* Information */}
        <div className='container mx-auto'>
          <div className='py-40'>
            <div className='flex flex-col justify-between gap-10 px-20 sm:gap-20 sm:flex-row sm:px-40'>
              <div className='flex flex-col gap-16'>
                <p className='text-title3-bold sm:text-title2-bold md:text-title1-bold text-sk-black'>
                  {portfolio.name}
                </p>
                <p className='text-body1-medium sm:text-h2-medium text-sk-info'>
                  {portfolio.description}
                </p>
              </div>
              <div className='flex flex-col sm:items-end sm:justify-end shrink-0'>
                {portfolio.client ? <p className='text-body2-medium text-sk-info'>Client</p> : null}
                <p className='text-body1-semibold sm:text-h2-semibold text-sk-sub'>
                  {portfolio.client}
                </p>
              </div>
            </div>
          </div>
          <div className='flex justify-center mb-48'>
            {portfolio.link ? (
              <a
                href={portfolio.link}
                target='_blank'
                rel='noreferrer'
                className='flex justify-center items-center gap-10 bg-[#0F0F10] rounded-40 px-36 sm:px-48 py-8 select-none cursor-pointer'
              >
                <p className='text-body2-semibold sm:text-body1-semibold text-sk-white'>바로가기</p>
                <img src={OpenIcon} alt='' />
              </a>
            ) : null}
          </div>
        </div>

        {/* bottomImg */}
        <div className='bg-[#F7F7F8] mb-20'>
          <div className='container mx-auto'>
            <div className='flex items-center justify-center'>
              <img src={portfolio.bottomImg} alt='' className='w-[1042px]' />
            </div>
          </div>
        </div>

        {/* Project Information */}
        <div className='container mx-auto'>
          <div className='px-20 py-32 sm:px-40'>
            <div className='flex gap-28 md:gap-80'>
              <div className='flex flex-col gap-4 shrink-0'>
                <p className='text-h2-semibold sm:text-h1-semibold text-sk-black'>Project</p>
                <p className='text-body2-regular sm:text-body1-regular text-sk-info'>
                  프로젝트 정보
                </p>
              </div>
              <div className='flex flex-col gap-[14px]'>
                <div className='flex flex-col gap-2 sm:gap-16 sm:flex-row'>
                  <p className='text-body3-semibold sm:text-body2-semibold text-sk-info shrink-0'>
                    프로젝트 분류
                  </p>
                  <p className='text-body2-medium sm:text-body1-medium text-sk-default'>
                    {portfolio.projectType}
                  </p>
                </div>
                <div className='flex flex-col gap-2 sm:gap-16 sm:flex-row'>
                  <p className='text-body3-semibold sm:text-body2-semibold text-sk-info shrink-0'>
                    프로젝트 설명
                  </p>
                  <p className='text-body2-medium sm:text-body1-medium text-sk-default'>
                    {portfolio.projectDescription}
                  </p>
                </div>
                <div className='flex flex-col gap-2 sm:gap-16 sm:flex-row'>
                  <p className='text-body3-semibold sm:text-body2-semibold text-sk-info shrink-0'>
                    프로젝트 기간
                  </p>
                  <p className='text-body2-medium sm:text-body1-medium text-sk-default'>
                    {portfolio.projectDuration}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
